import type { CSSProperties } from 'react';
import SectionHeading from '../components/SectionHeading';
import type { Colors } from '../theme';
import { SKILL_GROUPS } from '../data';

interface Props {
  colors: Colors;
  mobile: boolean;
  sectionStyle: CSSProperties;
}

export default function SkillsSection({ colors, mobile, sectionStyle }: Props) {
  const gridStyle = {
    display: "grid",
    gridTemplateColumns: mobile ? "1fr" : "repeat(auto-fit, minmax(210px, 1fr))",
    gap: mobile ? 32 : 40,
    width: "100%",
    textAlign: "left",
    alignItems: "start",
    // consumed by the .skill-item hover rules in index.css
    "--skill-hover-fg": colors.fg,
    "--skill-hover-accent": colors.accent,
  } as CSSProperties;

  const listStyle: CSSProperties = {
    display: "flex", flexDirection: "column", gap: 7,
    margin: "12px 0 0", padding: 0, listStyle: "none",
  };
  const itemStyle: CSSProperties = {
    fontSize: 13, lineHeight: 1.5, color: colors.muted, whiteSpace: "pre-wrap",
  };
  const punct: CSSProperties = { color: colors.muted, whiteSpace: "pre" };

  return (
    <section id="skills" style={sectionStyle}>
      <SectionHeading colors={colors} mobile={mobile}>
        [spandan@portfolio ~]$ cat skills.json
      </SectionHeading>

      <div style={gridStyle}>
        {SKILL_GROUPS.map((g, gi) => {
          const lastGroup = gi === SKILL_GROUPS.length - 1;
          return (
            // Each column is one slice of skills.json; read in order they form the whole file.
            <div key={g.name}>
              <p style={{ margin: 0, fontSize: 12, color: colors.muted }}>
                {gi === 0 ? "{" : " "}
              </p>
              <p style={{ margin: "6px 0 0", fontSize: 13 }}>
                <span style={punct}>{"  "}</span>
                <span style={{ color: colors.accent, fontWeight: 600 }}>{JSON.stringify(g.name)}</span>
                <span style={punct}>: [</span>
              </p>
              <ul style={listStyle}>
                {g.items.map((item, i) => (
                  // string values inherit the muted grey; .skill-item darkens on hover
                  <li key={item} className="skill-item" style={{ ...itemStyle, paddingLeft: "4ch" }}>
                    {JSON.stringify(item)}{i < g.items.length - 1 ? "," : ""}
                  </li>
                ))}
                <li style={{ ...itemStyle, paddingLeft: "2ch" }}>
                  <span style={punct}>]{lastGroup ? "" : ","}</span>
                </li>
                {lastGroup && <li style={itemStyle}><span style={punct}>{"}"}</span></li>}
              </ul>
            </div>
          );
        })}
      </div>
    </section>
  );
}
